import React from 'react';
import Dashboard from '@mui/icons-material/Dashboard';
import Settings from '@mui/icons-material/Settings';
import Assignment from '@mui/icons-material/Assignment';
import ReportProblem from '@mui/icons-material/ReportProblem';
import Autorenew from '@mui/icons-material/Autorenew';

const menuItems = [
  { icon: <Dashboard />, text: 'NavBar.Dashboard', path: '/dashboard', name: 'Dashboard', roles: ['Administrator'] },
  {
    icon: <Assignment />,
    text: 'NavBar.Insurance-Documents',
    path: '/insurance-documents',
    name: 'Insurance-Documents',
    roles: ['Administrator']
  },
  { icon: <Settings />, text: 'NavBar.Settings', path: '/settings', name: 'Settings', roles: ['Administrator'] },
  { icon: <ReportProblem />, text: 'NavBar.Logs', path: '/logs', name: 'Logs', roles: ['Administrator'] },
  {
    icon: <Autorenew />,
    text: 'NavBar.Policy-Renewal',
    path: '/renewal',
    name: 'Policy-Renewal',
    roles: ['Administrator']
  }
];

export default menuItems;
